const SDK_URL = 'https://cdn.yousign.tech/iframe-sdk-1.6.0.min.js';

let sdk: Promise<void>|null = null;
let opened: YousignIframeInterface|null = null;

export const isSandbox = (): boolean => document.querySelector('meta[name="yousign-sandbox"]')?.getAttribute('content') === '1';

const loadSdk = (): Promise<void> => {
  if (window.Yousign) {
    return Promise.resolve();
  }
  if (!sdk) {
    sdk = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SDK_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        sdk = null;
        reject(new Error('signature-module-unavailable'));
      };
      document.head.appendChild(script);
    });
  }

  return sdk;
};

export const openSignature = (containerId: string, signatureLink: string, sandbox: boolean): Promise<void> => loadSdk()
  .then(() => {
    opened?.removeMessageListener();
    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = '';
    }

    opened = new window.Yousign!({
      signatureLink,
      iframeContainerId: containerId,
      isSandbox: sandbox,
    });
  });
